import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconDeskphone",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], h = /* @__PURE__ */ o("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M0 1.5A1.5 1.5 0 0 1 1.5 0h1c.444 0 .843.193 1.118.5H8.5A1.5 1.5 0 0 1 10 2v6a1.5 1.5 0 0 1-1.5 1.5H3.618c-.275.307-.674.5-1.118.5h-1A1.5 1.5 0 0 1 0 8.5v-7Zm4 7h4.5A.5.5 0 0 0 9 8V2a.5.5 0 0 0-.5-.5H4v7ZM1.5 1a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-1Zm3 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V3Zm3 0h-2v1.5h2V3Zm-3 4a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5Z",
  fill: "currentColor"
}, null, -1), _ = [
  h
];
function m(e, u, i, p, f, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--deskphone"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Deskphone",
    viewBox: "0 0 10 10",
    xmlns: "http://www.w3.org/2000/svg"
  }, _, 10, c);
}
const Z = /* @__PURE__ */ s(l, [["render", m]]);
export {
  Z as default
};
//# sourceMappingURL=deskphone.js.map
